// extracted by mini-css-extract-plugin
module.exports = {"container":"BundleItemsMessage_container__2goRt","wrapper":"BundleItemsMessage_wrapper__2ATGa","subHeading":"BundleItemsMessage_subHeading__3qTL0"};